module.exports = __webpack_public_path__ + "static/media/SellerboxGuideKeyword.b634367a.png";